"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const _hoisted_2 = { class: "font-bold lg:hidden" };
const _hoisted_3 = {
    key: 0,
    class: "font-bold"
};
const _hoisted_4 = {
    key: 1,
    class: "font-bold"
};
const _hoisted_5 = {
    key: 2,
    class: "text-red-dark hide-foreign-customer"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { class: "relative marso-icon-info-circle tooltip text-blue mr-1" };
const _hoisted_8 = { class: "!flex !flex-col !gap-2 tooltip-content" };
const _hoisted_9 = { class: "text-base self-center" };
const _hoisted_10 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-promotion_gift" }, null, -1);
const tagStore_1 = require("../../../stores/tag/tagStore");
const index_1 = require("../../../common/i18n/index");
const shop_1 = require("../../../common/utils/shop");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ListPriceCell',
    props: {
        product: null
    },
    setup(__props) {
        const tagStore = (0, tagStore_1.useTagStore)();
        return (_ctx, _cache) => {
            return ((0, vue_2.unref)(tagStore).tags.columns.listPriceColumn.display)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("td", {
                    key: 0,
                    id: `list-price-cell-${__props.product.id}`,
                    class: "grid grid-cols-2 border-b border-gray px-4 py-2 lg:table-cell lg:py-1"
                }, [
                    (!__props.product.priceOptions.length)
                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 0 }, [
                            (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(index_1.trans)('list_price', 'List price', 'list_price_cell')), 1),
                            (0, vue_2.createElementVNode)("div", null, [
                                ((0, vue_2.unref)(tagStore).tags.switches.grossPriceSwitch.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceListNet + __props.product.prices.priceEcoNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode, { vatPercent: __props.product.prices.priceVatPercent })), 1))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_4, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(__props.product.prices.priceListNet + __props.product.prices.priceEcoNet, (0, vue_2.unref)(tagStore).customerCurrencyCode || __props.product.prices.currencyCode)), 1)),
                                ((100 - __props.product.prices.priceDiscountNet / (__props.product.prices.priceListNet / 100)) / 100 > 0 && !(0, vue_2.unref)(tagStore).tags.switches.retailPriceSwitch.value)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                                        (!__props.product.stocks.stockIhle && 0 < __props.product.stocks.stockIhle)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_6, [
                                                (0, vue_2.createElementVNode)("i", _hoisted_7, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                                        (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(index_1.trans)('remote_stock_information', 'Product available with individual pricing.', 'list_price_cell')), 1)
                                                    ])
                                                ]),
                                                (0, vue_2.createTextVNode)("️ ")
                                            ]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        _hoisted_10,
                                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(index_1.n)((100 - __props.product.prices.priceDiscountNet / (__props.product.prices.priceListNet / 100)) / 100, "percent")), 1)
                                    ]))
                                    : (0, vue_2.createCommentVNode)("", true)
                            ])
                        ], 64))
                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [], 64))
                ], 8, _hoisted_1))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
